import React from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiShield, FiAward, FiUsers, FiTrendingUp, FiStar, FiCheckCircle, FiClock, FiGlobe } = FiIcons;

const TrustBadges = () => {
  const badges = [
    {
      icon: FiAward,
      title: "Superhost Airbnb",
      description: "Certificazione ufficiale per eccellenza nel servizio"
    },
    {
      icon: FiStar,
      title: "Partner Booking.com",
      description: "Partner preferito con rating superiore a 9.0"
    },
    {
      icon: FiShield,
      title: "Assicurazione Completa",
      description: "Copertura danni fino a €50.000 per ogni prenotazione"
    },
    {
      icon: FiUsers,
      title: "150+ Clienti Attivi",
      description: "Proprietari che si fidano della nostra gestione"
    },
    {
      icon: FiTrendingUp,
      title: "+45% Ricavi Medi",
      description: "Aumento medio documentato sui nostri immobili"
    },
    {
      icon: FiCheckCircle,
      title: "98% Soddisfazione",
      description: "Tasso di soddisfazione clienti verificato"
    },
    {
      icon: FiClock,
      title: "Assistenza H24/7",
      description: "Supporto continuo per ospiti e proprietari"
    },
    {
      icon: FiGlobe,
      title: "Mercato Internazionale",
      description: "Gestione multilingue per ospiti da tutto il mondo"
    }
  ];

  const platforms = [
    {
      name: "Airbnb",
      // Utilizzo di una versione più stabile e ad alta risoluzione del logo Airbnb
      logo: "https://upload.wikimedia.org/wikipedia/commons/thumb/6/69/Airbnb_Logo_B%C3%A9lo.svg/2560px-Airbnb_Logo_B%C3%A9lo.svg.png",
      description: "La piattaforma leader mondiale per affitti brevi"
    },
    {
      name: "Booking.com",
      logo: "https://upload.wikimedia.org/wikipedia/commons/thumb/b/be/Booking.com_logo.svg/1280px-Booking.com_logo.svg.png",
      description: "Il portale di prenotazioni più utilizzato al mondo"
    }
  ];

  return (
    <>
      <section className="py-16 bg-white border-b border-brand-silver/20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <motion.div 
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            className="text-center mb-16"
          >
            <h2 className="text-3xl md:text-4xl font-black text-brand-blue mb-4 uppercase tracking-tight">
              L'Affidabilità di <span className="text-brand-gold">Castello SRL</span>
            </h2>
            <p className="text-brand-subtle max-w-2xl mx-auto text-lg font-medium">
              Certificazioni, risultati e garanzie che testimoniano la nostra eccellenza istituzionale
            </p>
          </motion.div>
          
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
            {badges.map((badge, index) => (
              <motion.div 
                key={index}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ delay: index * 0.05 }}
                className="text-center p-8 bg-brand-blue/5 rounded-3xl hover:shadow-xl transition-all group border border-brand-silver/10 hover:border-brand-gold/30"
              >
                <div className="bg-white w-14 h-14 rounded-2xl flex items-center justify-center mx-auto mb-6 shadow-md group-hover:bg-brand-gold transition-colors">
                  <SafeIcon icon={badge.icon} className="h-7 w-7 text-brand-blue group-hover:text-white" />
                </div>
                <h3 className="font-bold text-brand-blue mb-3 text-lg leading-tight uppercase tracking-tight">
                  {badge.title}
                </h3>
                <p className="text-sm text-brand-subtle leading-relaxed">
                  {badge.description}
                </p>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      <section className="py-16 bg-brand-blue/95">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-12 max-w-3xl mx-auto">
            {platforms.map((platform, index) => (
              <motion.div 
                key={index}
                initial={{ opacity: 0, scale: 0.95 }}
                whileInView={{ opacity: 1, scale: 1 }}
                className="bg-white rounded-3xl p-8 text-center shadow-2xl group border-b-4 border-brand-gold"
              >
                <div className="h-16 flex items-center justify-center mb-6">
                  <img 
                    src={platform.logo} 
                    alt={platform.name} 
                    className="max-h-12 max-w-full object-contain"
                    onError={(e) => {
                      // Fallback in caso di problemi di caricamento (molto raro con questo nuovo URL)
                      e.target.src = "https://1000logos.net/wp-content/uploads/2017/08/Airbnb-Logo.png";
                    }}
                  />
                </div>
                <h4 className="font-bold text-brand-blue mb-2 uppercase tracking-widest text-xs">{platform.name} STRATEGIC PARTNER</h4>
              </motion.div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
};

export default TrustBadges;